export default {"src":"/_next/static/image/public/images/flags/flag_374.d9b4d0eae62f1016944b1a705f49478b.svg","height":16,"width":25};